"use strict";

exports.__esModule = true;
exports.getUserLiquidTokenSummary = getUserLiquidTokenSummary;
var _sdkCore = require("@acala-network/sdk-core");
var _getEstimateRedeemResult = require("./get-estimate-redeem-result");
function getUserLiquidTokenSummary(env, currentRelayEra, unbondings, redeemRequest) {
  let [claimable, totalUnbonding] = [_sdkCore.FixedPointNumber.ZERO, _sdkCore.FixedPointNumber.ZERO];
  unbondings.forEach(_ref => {
    let {
      era: expiredEra,
      amount: unbonded
    } = _ref;
    if (expiredEra <= currentRelayEra) {
      claimable = claimable.add(unbonded);
    } else {
      totalUnbonding = totalUnbonding.add(unbonded);
    }
  });
  if (!redeemRequest.amount.isZero()) {
    totalUnbonding = totalUnbonding.add((0, _getEstimateRedeemResult.getEstimateRedeemResult)(env, redeemRequest.amount, redeemRequest.fastRedeem).receive);
  }
  return {
    totalUnbonding,
    claimable,
    currentRelayEra,
    // exclude claimable record
    unbondings: unbondings.filter(item => item.era > currentRelayEra),
    redeemRequest
  };
}